export const zIndex = {
  modal: 1,
  alert: 2,
  popover: 1,
  tooltip: 1,
  mobileNav: 1,
  toast: 2,
  swiper: 0,
} as const;
